import Div from "@jumbo/shared/Div/Div";

const TabPanel = ({children, value, index, ...other}) => (
    <div
        style={{backgroundColor: "#FFF"}}
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
    >
        {value === index && <Div sx={{p: 3}}>{children}</Div>}
    </div>
);

export default TabPanel;